import { initializeApp } from "firebase/app";
import { getFunctions, httpsCallable} from "firebase/functions";

// PRODUCTION
const firebaseConfig = {
	apiKey: "AIzaSyD8xdpvkEK9JQV_w-8KlrXM0_dEEYceTHk",
	authDomain: "schnappodil-2f0a7.firebaseapp.com",
	projectId: "schnappodil-2f0a7",
	storageBucket: "schnappodil-2f0a7.appspot.com",
	messagingSenderId: "1065166265872",
	appId: "1:1065166265872:web:12f7e675daf66ba562b495",
	measurementId: "G-VY15NF3M4B"
};

// STAGING
// const firebaseConfig = {
// 	apiKey: "AIzaSyCrPm7a7UHgEv-dDfGsM7SXV8B8q3UZnQU",
// 	authDomain: "lokodil-staging.firebaseapp.com",
// 	projectId: "lokodil-staging",
// 	storageBucket: "lokodil-staging.appspot.com",
// 	messagingSenderId: "407093951114",
// 	appId: "1:407093951114:web:109861064333b77b0f0b73",
// };

export const region = "europe-west3";

// Initialize Firebase
export let app = initializeApp(firebaseConfig);
let functions = getFunctions(app, region);
export const testFunction = httpsCallable(functions, "testFunction");

export const device_create = httpsCallable(functions, "device-create");
export const device_delete = httpsCallable(functions, "device-delete");

export const lottery_join = httpsCallable(functions, "lottery-join");
export const lottery_leave = httpsCallable(functions, "lottery-leave");
export const lottery_manualUsageReport = httpsCallable(functions, "lottery-manualUsageReport");

export const lotterySetting_publish = httpsCallable(functions, "lotterySetting-publish");

export const cardSetting_manualRefresh = httpsCallable(functions, "cardSetting-manualRefresh");
export const lotterySetting_manualRefresh = httpsCallable(functions, "lotterySetting-manualRefresh");

export const determineWinners = httpsCallable(functions, "determineWinners");
export const getGeocode = httpsCallable(functions, "getGeocode");

export const adminAccess_grant = httpsCallable(functions, "adminAccess-grant");
export const adminAccess_revoke = httpsCallable(functions, "adminAccess-revoke");

export const stripeCustomer_create = httpsCallable(functions, "stripeCustomer-create");
export const stripeCustomer_update = httpsCallable(functions, "stripeCustomer-update");
export const stripeCustomer_get = httpsCallable(functions, "stripeCustomer-get");
export const stripeCustomer_getPaymentMethods = httpsCallable(functions, "stripeCustomer-getPaymentMethods");
export const stripeCustomer_getActiveSubscriptions = httpsCallable(functions, "stripeCustomer-getActiveSubscriptions");
export const stripeCustomer_detachPaymentMethod = httpsCallable(functions, "stripeCustomer-detachPaymentMethod");
export const stripeCustomer_addPaymentMethod = httpsCallable(functions, "stripeCustomer-addPaymentMethod");
export const stripeCustomer_updateDefaultPaymentMethod = httpsCallable(functions, "stripeCustomer-updateDefaultPaymentMethod");

export const subscription_create = httpsCallable(functions, "subscription-create");
export const subscription_createFromSessionID = httpsCallable(functions, "subscription-createFromSessionID");
export const subscription_update = httpsCallable(functions, "subscription-update");
export const subscription_change = httpsCallable(functions, "subscription-change");
export const subscription_cancel = httpsCallable(functions, "subscription-cancel");
export const subscription_confirmPayment = httpsCallable(functions, "subscription-confirmPayment");
// export const subscription_confirmPaymentForSession = httpsCallable(functions, "subscription-confirmPaymentForSession");
export const subscription_confirmSession = httpsCallable(functions, "subscription-confirmSession");
export const subscription_confirmSetup = httpsCallable(functions, "subscription-confirmSetup");
export const subscription_updatePaymentMethod = httpsCallable(functions, "subscription-updatePaymentMethod");

export const getInvoices = httpsCallable(functions, "getInvoices");

export const createCustomerPortalLink = httpsCallable(functions, "ext-firestore-stripe-payments-createPortalLink");

